import { render, staticRenderFns } from "./CardLoadingIndicator.vue?vue&type=template&id=2c420d45&"
import script from "./CardLoadingIndicator.vue?vue&type=script&lang=js&"
export * from "./CardLoadingIndicator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/joelstorm/Sites/hanken-sse-website/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('2c420d45', component.options)
    } else {
      api.reload('2c420d45', component.options)
    }
    module.hot.accept("./CardLoadingIndicator.vue?vue&type=template&id=2c420d45&", function () {
      api.rerender('2c420d45', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vue/CardLoadingIndicator.vue"
export default component.exports